<template>
  <div>
    <v-container px-10 fill-height ms-auto class="pop-container"> 

      <v-stepper non-linear>
        <div class="c-stepper__header">
          <div tabindex="-1" class="c-stepper__step">
              <span class="c-stepper__step__step primary"><v-icon  icon="icon" color="white">mdi-file-upload</v-icon></span>
            <div class="c-stepper__label">{{ $let('DocPackUploadSectionTitle') }}</div>
          </div>
        </div>
      </v-stepper>

      <v-row no-gutters>
        <v-col>
          <v-sheet color="white" class="custom-shadow pa-10">   
          
          <div v-html="$let('DocPackUploadSectionSubTitle')" class="mb-5">/</div>

            <div v-for="item in docPackDS" :key="item.MemberDocumentPackDetailID">
              <FileUpload 
                @uploadFiles="_uploadFiles"
                :carryItem="item"
                :selectedFiles="files"
                :multiple="item.AllowMultipleUploadsOnline" 
                :disabled="item.DocumentStatus == 1"
                :label="item.DocumentTypeName + (item.DocumentStatus == 1 ? $let('UploadedFileStatusText') : '')"
                :entryLabel="$let('UploadFileFileEntry')"
                :allowedMultipleText="$let(item.AllowMultipleUploadsOnline ? 'MultipleFilesAllowed' : 'MultipleFilesNotAllowed')"
                :allowedExtensionsText="$let('AllowedUploadExtensions')"
                :allowedExtensions="allowedExtensions">
              </FileUpload>
            </div>
        
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  
  import { mapActions } from 'vuex';
  import FileUpload from '@/shared/components/file-upload.vue';
  import routerNames from '../router/router-names';
  import generic from '@/shared/utils/generic.js';
  import paramKeys from '../constants/param-keys.js';
  import constants from '../constants/generic.js';

  export default {
    name: 'DocPackUpload',
    components: {
      FileUpload, 
    },
    data() {
      return {
        allowedExtensions: '',
        docPackDS: [],
        files: [],
        model: {
          docPackInfo: undefined,
          docPackFiles: []
        }
      };
    },
    
    created() {
      this.docPackDS = this.$store.state.loanEnquiryConfig.DocPack;
      this.allowedExtensions = generic.paramValue(this.$store, paramKeys.AllowedFileExtensions);
      if (!this.docPackDS) this.$router.push({ name: routerNames.OpenEnquiry });
    },

    methods: {
      ...mapActions(["enquiryDoc"]),

      async uploadDocPackDocuments(){
        const resp = await this.enquiryDoc(this.model); 
        if (resp.Code === constants.LOAN_ENQUIRY_SUCCESS) {
          // Rfresh dockPack after upload
          this.docPackDS = this.$store.state.loanEnquiryConfig.DocPack;
        }
      },

      async _uploadFiles(docPackItem, files) {
        this.model.docPackInfo = docPackItem;
        this.model.docPackFiles = [];

        let thisModel = this.model;
        let filesProcessed = 0;
        files.forEach((file, idx, array) => {
          const reader = new FileReader();
          reader.onload = f => {
            filesProcessed++;
            if (f !== null) {
              thisModel.docPackFiles.push({ Data: f.target.result.split(",")[1], FileName: docPackItem.DocumentTypeName, FileExtension: file.name.split('.').pop() });
            }
            /// Last file read to base64 upload can start
            if (filesProcessed === array.length) this.uploadDocPackDocuments(); 
          }
          reader.readAsDataURL(file);
        });
      }
    },
  };
</script>

<style lang="scss" scoped>

</style>